import { PhoneInput } from 'components/Form/fields/Phone'
import React from 'react'

export const userSettingsFields = [
	{ id: 'phone', title: 'Телефон', component: <PhoneInput />, type: 'tel' },
	{ id: 'email', title: 'E-mail' },
]
